/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useRef, useEffect } from 'react';
import { SCREEN_SIZES } from 'style';
import useWindowSize from 'hooks/useWindowSize';
import { ReactComponent as PlayIcon } from 'products/global/assets/img/join-us/play.svg';
import {
  CardContainer,
  Content,
  ContentWrapper,
  PlayButton,
  Footer,
  Image,
  VideoContainer,
  StyledPin
} from './styled';

const Card = (StackedCarouselSlideProps) => {
  const [isContentVisible, setIsContentVisible] = useState(false);
  const [playButtonIsHidden, setPlayButtonIsHidden] = useState(false);
  const [hasPlayed, setHasPlayed] = useState(false);
  const { width: windowWidth } = useWindowSize();
  const isTablet = windowWidth < SCREEN_SIZES.desktop;
  const { data, dataIndex, isCenterSlide, swipeTo, slideIndex } =
    StackedCarouselSlideProps;
  const videoRef = useRef();

  const onCardClick = () => {
    if (!isCenterSlide) {
      swipeTo(slideIndex);
      setIsContentVisible(false);
    } else {
      setIsContentVisible(!isContentVisible);
    }
  };

  const playVideo = () => {
    setHasPlayed(true);
    setPlayButtonIsHidden(true);
    videoRef?.current?.setAttribute('controls', 'controls');

    videoRef?.current?.play();
  };

  const pauseVideo = () => {
    setPlayButtonIsHidden(false);
  };

  useEffect(() => {
    const video = videoRef?.current;
    setHasPlayed(false);

    if (video) {
      setPlayButtonIsHidden(false);
      video.pause();
      video.removeAttribute('controls');
      video.currentTime = 0;
    }
  }, [isCenterSlide]);

  return (
    <CardContainer
      onClick={onCardClick}
      $isCenterSlide={isCenterSlide}
      onMouseEnter={() => (isCenterSlide && !isTablet ? setIsContentVisible(true) : null)}
      onMouseLeave={() =>
        isCenterSlide && !isTablet ? setIsContentVisible(false) : null
      }
    >
      {data[dataIndex].type === 'video' ? (
        <>
          <VideoContainer>
            {!playButtonIsHidden && (
              <PlayButton onClick={() => playVideo()}>
                <PlayIcon />
              </PlayButton>
            )}
            {!hasPlayed && <Image fullHeight photo={data[dataIndex].photo} />}
            <video
              ref={videoRef}
              onPause={pauseVideo}
              onPlay={() => {
                setHasPlayed(true);
                setPlayButtonIsHidden(true);
              }}
            >
              <source src={data[dataIndex].video} type="video/mp4" />
            </video>
          </VideoContainer>
          <ContentWrapper
            animate={{ y: 'calc(100% - 60px)' }}
            transition={{ duration: 0.15, type: 'tween', ease: 'linear' }}
            $isPlaying={playButtonIsHidden}
          >
            <Footer>
              <h1>{data[dataIndex].name}</h1>
              <div>
                <StyledPin /> {data[dataIndex].location}
              </div>
            </Footer>
            <Content>{data[dataIndex].description}</Content>
          </ContentWrapper>
        </>
      ) : (
        <>
          <Image photo={data[dataIndex].photo} />
          <ContentWrapper
            animate={{ y: isContentVisible ? 0 : 'calc(100% - 60px)' }}
            transition={{ duration: 0.15, type: 'tween', ease: 'linear' }}
          >
            <Footer>
              <h1>{data[dataIndex].name}</h1>
              <div>
                <StyledPin /> {data[dataIndex].location}
              </div>
            </Footer>
            <Content>{data[dataIndex].description}</Content>
          </ContentWrapper>
        </>
      )}
    </CardContainer>
  );
};

export default Card;
